import { __rest, __assign } from 'tslib';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { renderProp } from '../utils/renderProp.js';
import { SelectableOptions } from '../Selectable/SelectableOptions.js';
import { useSelectableContext } from '../Selectable/SelectableProvider.js';
import { SelectableOption } from '../Selectable/SelectableOption.js';
import { SelectableOptionsFocus } from '../Selectable/SelectableOptionsFocus.js';

var SelectLegacyDropdownOptions = function (_a) {
    var children = _a.children, _b = _a.disableOptionFocus, disableOptionFocus = _b === void 0 ? false : _b, sx = _a.sx, props = __rest(_a, ["children", "disableOptionFocus", "sx"]);
    var _c = useSelectableContext(), multiple = _c.multiple, options = _c.options;
    var forwardStyles = __assign({ maxHeight: "500px", overflow: "auto" }, sx);
    return (jsxs(Fragment, { children: [!disableOptionFocus && jsx(SelectableOptionsFocus, {}), jsx(SelectableOptions, __assign({}, props, { sx: forwardStyles }, { children: options.map(function (option) { return (jsx(SelectableOption, __assign({ option: option }, { children: renderProp({
                        prop: children,
                        context: option,
                        fallback: multiple ? null : option.label,
                    }) }), option.value)); }) }))] }));
};

export { SelectLegacyDropdownOptions };
//# sourceMappingURL=SelectLegacyDropdownOptions.js.map
